<clx-row type="button">
    <clx-item is="application-set-selection">
        <clx-label i18n="@@operating.schedule-batch-upgrade.select-applications-sets">Filter by Application Sets:</clx-label>
        <clx-multiselect
            selectBoxName="batch-upgrade-applicationset-list"
            (valueChanged)="filterByAppplicationSet($event)"
            name="applicationsets"
            [filterEnabled]="true"
            test-id="operating.schedule-batch-upgrade.application-set"
        >
            <clx-value *ngFor="let entry of applicationSets" [value]="entry.name">{{ entry.name }}</clx-value>
        </clx-multiselect>
    </clx-item>
    <clx-item has="right-aligment">
        <clx-button
            *ngIf="!isProxyTenant"
            (onClick)="upgradeDialog.open()"
            test-id="sites.button.batchupgrade"
            has-privileges="SiteBatchUpgrade"
            i18n="@@operating.schedule-batch-upgrade.button"
        >Schedule batch upgrade</clx-button>
    </clx-item>
</clx-row>

<span test-id="administration.upgrade.batchupgrade.tags">
    <clx-tag *ngFor="let selectedPlantName of selectedPlantNames"
                            [text]="selectedPlantName.name"
                            (click)="deselectPlant(selectedPlantName.siteId)"></clx-tag>
</span>

<plant-list
    id="assigned-plants-5"
    [remoteOperations]="remoteOperations"
    [source]="assignedSource"
    [showAssignColumn]="false"
    test-id="administration.grid.plants"
    route="/Administration/Plants/:plantid"
    [allPlantIds]="allPlantIds"
    [(selectedPlants)]="selectedPlants"
    [disabledColumns]="[
        'WebPictureFileId',
        'IsOnline',
        'RawAlarmStatus',
        'TaskStatus'
    ]"
    [isPlantAdministrationPage]="true"
    [isBatchUpgradePage]="true"
    [showSystemName]="hasSystemPrivilege"
    [showSystemSortIndex]="hasSystemPrivilege"
    [showPlantSelection]="true"
></plant-list>
<batch-upgrade-configuration #upgradeDialog [selectedPlants]="selectedPlants"></batch-upgrade-configuration>